import { render, staticRenderFns } from "./FieldSortOrderComponent.vue?vue&type=template&id=c9b1e1a0"
import script from "./FieldSortOrderComponent.vue?vue&type=script&lang=js"
export * from "./FieldSortOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports